import React from 'react';
import PropTypes from 'prop-types';
import { StyledTag } from './style';

const defaultProps = {
  size: 'short',
  rounded: true,
  customStyle: {
    width: 'content-fit',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px'
  }
};

export const Tag = ({ children, ...props }) => {
  const customStyle = { ...defaultProps.customStyle, ...props.customStyle };

  return (
    <StyledTag {...props} customStyle={customStyle}>
      {children}
    </StyledTag>
  );
};

Tag.defaultProps = defaultProps;

Tag.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Color of the Tag
   */
  color: PropTypes.bool.isRequired,
  /**
   * The style of overriding Tag styles
   */
  customStyle: PropTypes.shape({
    borderBottomLeftRadius: PropTypes.string,
    borderBottomRightRadius: PropTypes.string,
    borderTopLeftRadius: PropTypes.string,
    borderTopRightRadius: PropTypes.string,
    width: PropTypes.string
  }),
  /**
   * Whether has border radius
   */
  rounded: PropTypes.bool,
  /**
   * Height of the Tag
   */
  size: PropTypes.oneOf(['short', 'tall'])
};

export default Tag;
